import React from 'react';
import "./RecipeIngredientForm.css";

function RecipeIngredientForm({ idNum, ingredient, changeHandler, removeIngredient }) {

    function onChange(e) {   
        if(e.target.reportValidity())
            changeHandler(e.target.name, e.target.value, idNum)
    }

    function onBlur(e) {
        changeHandler(e.target.name, e.target.value.trim(), idNum)
    }

    return (
        <div key={idNum} className="recipe-ingredient-form-container">
            <label className="form-element recipe-ingredient" >Ingredient Name:
                <input type="text"
                    className="recipe-ingredient-element"
                    id={"Recipe_Ingredient_Name_" + idNum}
                    name="Ingredient_Name"
                    value={ingredient.Ingredient_Name}
                    placeholder="Name..."
                    maxLength="45"
                    onChange={onChange}
                    onBlur={ onBlur }
                    pattern="(?!.*[;]).*"
                    required
                />
            </label>
            <label className="form-element recipe-ingredient" >Ingredient Quantity:
                <input type="number"
                    className="recipe-ingredient-element"
                    id={"Recipe_Ingredient_Quantity_" + idNum}
                    name="Ingredient_Quantity"
                    value={ingredient.Ingredient_Quantity}
                    placeholder="Quantity..."
                    min="0"
                    max="2147483647"
                    onChange={onChange}
                    onFocus={e => e.target.select()}
                    required
                />
            </label>
            <input type="button" className="recipe-ingredient-element" id={"Remove_Ingredient_" + idNum} onClick={removeIngredient} value="X" />
        </div>
    )
}

export default RecipeIngredientForm;